module.exports = __webpack_public_path__ + "img/file-certificate.bb5f8666.svg";